<div class="modal-content">
  <div class="modal-header">
    <div class="row">
      <div class="col-12 text-center">
        <label for="">
          {{photo.fileName ? 'PHOTO: ' + photo.fileName :
          photo.fileName}}</label
        >
      </div>
    </div>
    <button type="button" class="close" (click)="dismiss()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="49"
        height="46"
        viewBox="0 0 49 46"
        fill="none"
      >
        <path
          d="M30.3473 16.9703L18.2084 28.284M18.2084 16.9703L30.3473 28.284"
          stroke="#202D41"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
  <div class="modal-body horizon-mobile">
    <div class="row">
      <div class="col-12 text-center">
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-center" style="cursor: pointer">
            <div
              class="view-photo d-flex justify-content-center"
              [style.width]="widthRotate"
              [style.height]="heightRotate"
            >
              <img
                class="main-photo"
                [src]="photo.url"
                id="photo-{{id}}"
                [ngClass]="getRotate()"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <div class="photo-control d-flex justify-content-between mt-3">
              <div class="d-flex">
                <a
                  [ngClass]="rotatePhoto === 1 ? 'disabled-button' : ''"
                  (click)="rotatePrevious()"
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 256 256"
                    enable-background="new 0 0 256 256"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <path
                          fill="#000000"
                          d="M66.2,103.7L48.7,86.2c-11.2,15-18.7,31.2-20,48.7h25C55,123.6,60,113.6,66.2,103.7z M53.7,159.8h-25c2.5,17.5,8.7,33.7,20,48.7L66.2,191C60,181.1,55,171.1,53.7,159.8z M66.2,226c15,11.2,31.2,17.5,48.7,20v-25c-11.2-1.3-21.2-6.2-31.2-12.5L66.2,226z M139.9,48.7V10L83.7,66.2l56.2,56.2V73.7c35,6.2,62.4,36.2,62.4,73.7c0,37.4-27.5,67.4-62.4,73.7v25c48.7-6.2,87.4-48.7,87.4-98.6S188.6,55,139.9,48.7z"
                        />
                      </g>
                    </g>
                  </svg>
                </a>
                <a
                  [ngClass]="rotatePhoto === 4 ? 'disabled-button' : ''"
                  (click)="rotateNext()"
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 256 256"
                    enable-background="new 0 0 256 256"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <path
                          fill="#000000"
                          d="M189.3,190.5c6.6-9,10.9-19.3,12.8-30.9h25.1c-2.3,17.9-9,34.1-19.9,48.5L189.3,190.5z M140.8,220.9c11.7-2,22-6.2,30.9-12.8l18.1,18.1c-14,10.9-30.4,17.5-49.1,19.9L140.8,220.9L140.8,220.9z M227.3,135h-25.1c-2-11.7-6.2-22-12.8-30.9l18.1-17.5C218.3,100.9,224.9,117.1,227.3,135L227.3,135z M173,66.7l-56.7,55.5V73.7c-17.9,3.1-32.8,11.6-44.7,25.4c-11.9,13.8-17.8,29.9-17.8,48.2c0,18.3,5.9,34.4,17.8,48.2c11.9,13.8,26.8,22.3,44.7,25.4V246c-24.5-3.1-45.3-14-62.2-32.7c-17-18.7-25.4-40.7-25.4-66c0-25.3,8.5-47.3,25.4-66c16.9-18.7,37.7-29.6,62.2-32.7V10L173,66.7z"
                        />
                      </g>
                    </g>
                  </svg>
                </a>
              </div>
              <div class="d-flex">
                <a
                  [ngClass]="levelZoom === 4 ? 'disabled-button' : ''"
                  (click)="zoomIn()"
                >
                  <svg
                    fill="#000000"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        d="M497.938,430.063l-112-112c-0.313-0.313-0.637-0.607-0.955-0.909C404.636,285.403,416,248.006,416,208
                                                C416,93.313,322.695,0,208,0S0,93.313,0,208s93.305,208,208,208c40.007,0,77.404-11.364,109.154-31.018
                                                c0.302,0.319,0.596,0.643,0.909,0.955l112,112C439.43,507.313,451.719,512,464,512c12.281,0,24.57-4.688,33.938-14.063
                                                C516.688,479.203,516.688,448.797,497.938,430.063z M64,208c0-79.406,64.602-144,144-144s144,64.594,144,144
                                                c0,79.406-64.602,144-144,144S64,287.406,64,208z"
                      />
                      <path
                        d="M272,176h-32v-32c0-17.672-14.328-32-32-32s-32,14.328-32,32v32h-32c-17.672,0-32,14.328-32,32s14.328,32,32,32h32v32
                                                c0,17.672,14.328,32,32,32s32-14.328,32-32v-32h32c17.672,0,32-14.328,32-32S289.672,176,272,176z"
                      />
                    </g>
                  </svg>
                </a>
                <a
                  [ngClass]="levelZoom === 0 ? 'disabled-button' : ''"
                  (click)="zoomOut()"
                >
                  <svg
                    fill="#000000"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        d="M497.938,430.063l-112-112c-0.367-0.367-0.805-0.613-1.18-0.965C404.438,285.332,416,248.035,416,208
                                        C416,93.313,322.695,0,208,0S0,93.313,0,208s93.305,208,208,208c40.035,0,77.332-11.563,109.098-31.242
                                        c0.354,0.375,0.598,0.813,0.965,1.18l112,112C439.43,507.313,451.719,512,464,512c12.281,0,24.57-4.688,33.938-14.063
                                        C516.688,479.203,516.688,448.797,497.938,430.063z M64,208c0-79.406,64.602-144,144-144s144,64.594,144,144
                                        c0,79.406-64.602,144-144,144S64,287.406,64,208z"
                      />
                      <path
                        d="M272,176H144c-17.672,0-32,14.328-32,32s14.328,32,32,32h128c17.672,0,32-14.328,32-32S289.672,176,272,176z"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              <a
                [href]="photo?.url"
                target="_blank"
                [download]="photo?.url"
                alt="download"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 17H17.01M17.4 14H18C18.9319 14 19.3978 14 19.7654 14.1522C20.2554 14.3552 20.6448 14.7446 20.8478 15.2346C21 15.6022 21 16.0681 21 17C21 17.9319 21 18.3978 20.8478 18.7654C20.6448 19.2554 20.2554 19.6448 19.7654 19.8478C19.3978 20 18.9319 20 18 20H6C5.06812 20 4.60218 20 4.23463 19.8478C3.74458 19.6448 3.35523 19.2554 3.15224 18.7654C3 18.3978 3 17.9319 3 17C3 16.0681 3 15.6022 3.15224 15.2346C3.35523 14.7446 3.74458 14.3552 4.23463 14.1522C4.60218 14 5.06812 14 6 14H6.6M12 15V4M12 15L9 12M12 15L15 12"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
